import "./index.css";

export function App() {
  return (
    <main className="page-shell">
      <section className="hero-card">
        <p className="eyebrow">miroslava.city</p>
        <h1>Coming soon</h1>
        <p className="description">
          A new digital home for Miroslava is on the way.
        </p>
      </section>
    </main>
  );
}

export default App;
